<ng-container *ngIf="!isTogglable; else toggleButton">
   <button
      kendoButton
      fxFlex="1 1 auto"
      [disabled]="!(actionEntry | isDynamicActionExecutable | async)"
      [toggleable]="false"
      [innerHtml]="actionEntry?.title | safeHtml"
      (click)="click()"
   ></button>
</ng-container>

<ng-template #toggleButton>
   <button
      kendoButton
      fxFlex="1 1 auto"
      [disabled]="!(actionEntry | isDynamicActionExecutable | async)"
      [selected]="actionEntry | isDynamicActionToggled | async"
      [toggleable]="true"
      [innerHtml]="actionEntry?.title | safeHtml"
      (selectedChange)="selectedChange($event)"
   ></button>
</ng-template>
